module.exports = __webpack_public_path__ + "static/tecne-logo-018d2bc36dfd0a8646f41825abffe9c1.jpg";